// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.note-text {
  resize: none;
  border: none Transparent;
  outline: none;
  height: 100%;
  overflow: hidden;
  color: #2C2B2D;
  font-family: Inter;
  font-style: normal;
  font-weight: 600;
  font-size: 13px;
}

.save-note {
  margin-top: 5px;
  margin-bottom: 1%;
}

.note-container {
  background-color: white;
  padding: 3%;
}

.note-form {
  height: 100%;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
